import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { ConfirmPurchaseLoading } from '@app/components/ConfirmPurchaseLoading';
import { resetChangePlan, selectChangePlan, selectChosenPlan } from '@app/redux/changePlan';
import { formatTimeInterval } from '@app/redux/scheduleInstallation';

import SubmitError from '../../components/Errors/SubmitError';
import ConfirmationWithEquipmentChange from './ConfirmationWithEquipmentChange';
import ConfirmationWithoutEquipmentChange from './ConfirmationWithoutEquipmentChange';
import { NavigationHandlers } from '../../types';

const OrderOutcome = ({ navigateToOverview }: Pick<NavigationHandlers, 'navigateToOverview'>) => {
  const dispatch = useDispatch();
  const { loading, error, orderSuccess, installationAppointment, requiresEquipmentChange } =
    useSelector(selectChangePlan);

  const goToOverview = () => {
    dispatch(resetChangePlan());
    navigateToOverview();
  };

  const { t } = useTranslation('ChangePlan', {
    keyPrefix: 'orderConfirmation.withEquipmentChange',
  });

  if (loading) {
    return <ConfirmPurchaseLoading title={'confirmPurchase.title'} description={'confirmPurchase.description'} />;
  }

  if (error || !orderSuccess) {
    return <SubmitError navigateToOverview={goToOverview} />;
  }

  const content = installationAppointment?.['startTime']
    ? t('alertContent', {
        DATE: new Date(installationAppointment?.['startTime']),
        TIME: formatTimeInterval([
          installationAppointment?.['startTime'] ?? '',
          installationAppointment?.['endTime'] ?? '',
        ]),
      })
    : t('alertContentUnscheduled');

  if (requiresEquipmentChange) {
    return <ConfirmationWithEquipmentChange goToOverview={goToOverview} content={content} />;
  }

  return <ConfirmationWithoutEquipmentChange navigateToOverview={goToOverview} />;
};

export default OrderOutcome;
